import { api } from '@api'

import { UpdateSupplierData } from '../../types'

interface UpdateSupplierResponse {
  message: string
}

const updateSupplier = async (supplierId: number, data: UpdateSupplierData) => {
  const supplierData = {
    supplier: {
      businessName: data.businessName,
      cellphone: data.cellphone,
      country: data.country,
      email: data.email,
      mgmtId: data.mgmtId,
      sapId: data.sapId,
      tradeName: data.tradeName,
      disabled: data.disabled,
    },
  }
  const response = await api.put<UpdateSupplierResponse>(`/suppliers/${supplierId}`, supplierData)

  return response.data.message
}

export const SuppliersApi = {
  updateSupplier,
}
